<template>
  <div>
    <base-header class="pb-8 pt-4">
      <!-- Card stats -->
      <div class="row">
        <div class="col-sm-12 col-md-3">
          <stats-card
              title="Ürün"
              :sub-title="productsCount"
              icon="fas fa-chart-bar text-white"
              class="mb-4 mb-xl-0 bg-gradient-info">
          </stats-card>
        </div>
        <div class="col-sm-12 col-md-3">
          <stats-card
              title="Kategori"
              :sub-title="categoriesCount"
              icon="fas fa-chart-pie"
              class="mb-4 mb-xl-0 bg-gradient-danger">
          </stats-card>
        </div>
        <div class="col-sm-12 col-md-3">
          <stats-card
              title="Marka"
              :sub-title="brandsCount"
              icon="ni ni-diamond"
              class="mb-4 mb-xl-0 bg-gradient-green">
          </stats-card>
        </div>
<!--        <div class="col-sm-12 col-md-3">-->
<!--          <stats-card-->
<!--              title="Bu Ay Kiralanan"-->
<!--              :sub-title="monthlyLeaseCount"-->
<!--              icon="ni ni-diamond"-->
<!--              class="mb-4 mb-xl-0 bg-gradient-warning">-->
<!--          </stats-card>-->
<!--        </div>-->


      </div>

      <div class="d-md-flex flex-md-wrap justify-content-around mt-4" v-if="getType!='all'">
        <div class="mt-2" v-for="(category,key) in categories.filter(cat=> cat.text!='Tüm Kategoriler')"
             :key="category.text">
          <stats-card
              style="max-height: 82px;min-width: 130px"
              :title="category.text"
              :sub-title="category.itemcount"
              :class="'mb-4 mb-xl-0 bg-gradient-'+['info','warning','blue','green','primary','danger','dark'][key%7]"
          >
          </stats-card>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col d-flex align-items-center">
              <h3 class="card-title mb-0">Ürün Yönetimi</h3>
              <div class="text-sm ml-4" style="width:200px;">
                <b-form-group class="mb-0">
                  <b-form-input placeholder="Ürün adı veya barkod" v-model="keyword" debounce="500"/>
                </b-form-group>
              </div>
              <div class="text-sm ml-4" style="width:200px;">
                <b-form-group class="mb-0">
                  <b-form-select v-model="brand" :options="brands" @change="refreshTable"/>
                </b-form-group>
              </div>
              <div class="text-sm ml-4" style="width:200px;">
                <b-form-group class="mb-0">
                  <b-form-select v-model="category" :options="categories" @change="changeCategory"/>
                </b-form-group>
              </div>
              <div class="text-sm ml-4" style="width:200px;" v-if="companies.length>0">
                <b-form-group class="mb-0">
                  <b-form-select v-model="company" :options="companies" @change="cPage=1; refreshTable();"/>
                </b-form-group>
              </div>
              <div class="text-sm ml-4" style="width:200px;">
                <b-form-group class="mb-0">
                  <b-form-select v-model="perPage" :options="[
                      5,7,10,20,50,100
                  ]" @change="refreshTable"/>
                </b-form-group>
              </div>
              <div class="d-flex align-items-center text-sm ml-4" style="width:200px;">
                <b-form-checkbox v-model="orderByStock" @change="refreshTable">{{
                    $t("Stoku azalan ürünler")
                  }}
                </b-form-checkbox>
              </div>
            </div>
            <div class="col text-right" v-if="getType!=='all'">
              <b-button @click="service={tax:0,used_time:0};$refs.modal.show()" variant="primary">+ {{ $t("Yeni Ürün Ekle") }}</b-button>
            </div>
          </div>
        </b-card-header>

        <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="getItems"
                 responsive show-empty>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show>{{ $t("Henüz bir şey eklenmemiş") }}!</b-alert>
          </template>

          <template v-slot:cell(barcode)="data">
            <a href="#" class="text-underline" @click.prevent="openBarcodeModal(data.item)">{{ data.item.barcode }}</a>
          </template>

          <template v-slot:cell(name)="data">
            <span
                :class="data.item.stock==0 ? 'bg-danger text-white font-weight-bolder p-2' : ''"> {{
                data.item.name
              }}</span>
          </template>

          <template v-slot:cell(category)="data">
            {{ data.item.category != null ? data.item.category.name : 'Kategori Yok' }}
          </template>

          <template v-slot:cell(price)="data">
            {{ data.item.price }} TL
          </template>

          <template v-slot:cell(total)="data">
            {{ Math.ceil(data.item.total) }} TL
          </template>

          <template v-slot:cell(tax)="data">
            {{ data.item.tax }} %
          </template>

          <template v-slot:cell(lease_count)="data">
            {{ data.item.lease_count }} ({{ data.item.lease_price_sum }} TL {{ $t("ciro") }})
          </template>

          <template v-slot:cell(daycount)="data">
            {{ data.item.daycount > 0 ? data.item.daycount+" Gün" : 'Süresiz' }}
          </template>

          <template v-slot:cell(stock)="data">
            <span v-if="data.item.stock === -1">Limitsiz</span>
            <div v-else class="d-flex align-items-center">
              <!--              <span>{{ data.item.stock - data.item.active_lease_count }}</span>-->
              <span>{{ data.item.active_stock }}</span>
              <div>
                <div>

                  <b-badge v-if="data.item.active_lease_count > 0" class="ml-2"
                           variant="warning">+ {{ data.item.active_lease_count }} {{ $t("Adet Kirada") }}
                  </b-badge>
                </div>
                <div>

                  <b-badge v-if="data.item.active_tailor_count > 0" class="ml-2"
                           variant="info">+ {{ data.item.active_tailor_count }} {{ $t("Adet Terzide") }}
                  </b-badge>
                </div>
                <div>
                  <b-badge v-if="data.item.active_dry_count > 0" class="ml-2"
                           variant="primary">+ {{ data.item.active_dry_count }} {{ $t("Adet Kuru Temizlemede") }}
                  </b-badge>

                </div>
              </div>
            </div>
          </template>

          <template v-slot:cell(actions)="data">
            <div class="d-flex flex-column " v-if="getType!='all'">
<!--              <b-button variant="outline-success" @click.prevent="rentModal(data.item)" size="sm"-->
<!--                        class="btn-block mb-1">{{ $t("Kira Takvimi") }}-->
<!--              </b-button>-->
<!--              <b-button variant="outline-warning" @click.prevent="leaseModal(data.item)" size="sm"-->
<!--                        class="btn-block mb-1">{{ $t("Kiraya Ver") }}-->
<!--              </b-button>-->
              <b-button variant="info" size="sm" @click.prevent="editService(data.item)" class="btn-block mb-1">
                {{ $t("Düzenle") }}
              </b-button>
              <b-button variant="danger" size="sm" @click.prevent="deleteAction(data.item.id)" class="btn-block mb-1">
                {{ $t("Sil") }}
              </b-button>
            </div>
          </template>

        </b-table>

        <div class="w-100 text-center d-flex-wrap align-items-center justify-content-center mt-2 mb-3">
          <b-button variant="secondary" v-if="cPage!=1" @click="cPage=1; refreshTable();"><<</b-button>
          <b-button variant="secondary" v-if="cPage!=1"
                    @click="cPage-10>=1 ? cPage=cPage-10 : cPage=1; refreshTable();"><
          </b-button>
          <b-button :variant="cPage==page ? 'primary':'secondary'" v-for="page in services.last_page"
                    @click="cPage=page; refreshTable();" v-bind:key="page" v-if="page<(cPage+5) && (page>cPage-5)">
            {{ page }}
          </b-button>

          <b-button variant="secondary" v-if="cPage!=services.last_page"
                    @click="cPage+10<=services.last_page ? cPage=cPage+10 : cPage=services.last_page; refreshTable();">
            >
          </b-button>
          <b-button variant="secondary" v-if="cPage!=services.last_page"
                    @click="cPage=services.last_page; refreshTable();"> >>
          </b-button>
        </div>

        <!--        <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 14">-->
        <!--          <b-pagination v-model="pagination.currentPage" :total-rows="pagination.totalRows" :per-page="pagination.perPage" @change="refreshTable" />-->
        <!--        </div>-->
      </b-card>
    </div>

    <b-modal ref="leaseModal" id="leaseModal" title="Ürün Kiralama">
      <b-form-group>
        <label>Müşteri Seçimi</label>
        <b-form-select v-model="lease.client_id" :options="clients"/>
      </b-form-group>
      <b-row>
        <b-col>
          <b-form-group>
            <label>Alış Tarihi</label>
            <b-form-input type="date" v-model="lease.issue_date"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label>Teslim Tarihi</label>
            <b-form-input type="date" v-model="lease.delivery_date"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group>
            <label>Toplam Ücret</label>
            <b-form-input type="number" v-model="lease.total_price"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <label>Peşinat</label>
            <b-form-input type="number" v-model="lease.price"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group>
        <label>Notlar</label>
        <b-form-textarea v-model="lease.notes"/>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="default" @click="$refs.leaseModal.hide()">İptal</b-button>
        <b-button variant="primary" @click="leaseProduct">Kiraya Ver</b-button>
      </template>
    </b-modal>

    <b-modal ref="rentModal" size="xl" id="rentModal" :title="activeItem+ ' Kiralama Takvimi'">
      <b-row class="font-weight-bolder">
        <b-col>
          {{ $t("S.No") }}
        </b-col>
        <b-col>
          {{ $t("Kiraya Verilen Kişi") }}
        </b-col>
        <b-col>
          {{ $t("Kiraya Verilen Tarih") }}
        </b-col>
        <b-col>
          {{ $t("Teslim Alınan Tarih") }}
        </b-col>
        <b-col>
          {{ $t("Tutar") }}
        </b-col>
        <b-col>
          {{ $t("Durum") }}
        </b-col>

      </b-row>
      <b-row v-for="(rent,index) in rents" v-bind:key="index" :class="'py-2'+(index%2==0 ? ' bg-light' : '')">
        <b-col>{{ index + 1 }}</b-col>
        <b-col>{{ rent.client != undefined ? rent.client.full_name : 'Belirtilmemiş' }}</b-col>
        <b-col>{{ rent.issue_date }}</b-col>
        <b-col>{{ rent.delivery_date }}</b-col>
        <b-col>{{ rent.total_price }} TL</b-col>
        <b-col>
          <div :class="'badge badge-'+(rent.status=='active' ? 'success' : 'warning')">
            {{ rent.status == 'active' ? 'Kirada' : 'Teslim Alındı' }}
          </div>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <b-button variant="default" @click="$refs.rentModal.hide()">{{ $t("Kapat") }}</b-button>
      </template>
    </b-modal>

    <b-modal ref="modal" title="Ürün / Hizmet Kaydı" @hide="resetModal">

      <b-row>
        <b-col>
          <b-form-group label="Ürün Adı">
            <b-form-input v-model="service.name"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Barkod">
            <b-form-input v-model="service.barcode"/>
          </b-form-group>
        </b-col>

      </b-row>

<!--      <b-row>-->
<!--        <b-col  v-if="user.yearsize_permission">-->
<!--          <b-form-group label="Beden">-->
<!--            <b-form-select v-model="service.size" :options="['36','38','40','42','44','46','48']"/>-->
<!--          </b-form-group>-->
<!--        </b-col>-->
<!--        <b-col  v-if="user.yearsize_permission">-->
<!--          <b-form-group label="Ürün Yılı">-->
<!--            <b-form-input type="number" min="1950" max="2050" v-model="service.year"/>-->
<!--          </b-form-group>-->
<!--        </b-col>-->
<!--      </b-row>-->

      <b-row>
        <b-col>
          <b-form-group label="Birim">
            <b-form-select v-model="service.unit" :options="dependencies['units']"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__214__BV_label_">Stok <span
                style="font-size:12px">{{ $t("Limitsiz için") }} <b-badge variant="default">-1</b-badge> {{
                $t("girin")
              }}</span></legend>
            <b-form-input v-model="service.stock"/>
          </b-form-group>
        </b-col>

      </b-row>

      <b-row>
        <b-col>
          <label class="d-flex-align-items-center">
            <switches v-model="service.hizmetsuresi" theme="custom" color="red" />
            <span>Süreli Hizmet</span>
          </label>
          <b-form-group v-if="service.hizmetsuresi">
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__214__BV_label_">Hizmet Süresi (Gün Olarak Giriniz) </legend>
            <b-form-input v-model="service.daycount"/>
          </b-form-group>
        </b-col>

      </b-row>

      <b-row>
<!--        <b-col>-->
<!--          <b-form-group label="Kaç Kez Kullanıldı">-->
<!--            <b-form-input type="number" min="0" max="1" v-model="service.used_time"/>-->
<!--          </b-form-group>-->
<!--        </b-col>-->
        <b-col>
          <b-form-group label="Marka">
            <b-form-select v-model="service.brand_id"
                           :options="[{text: 'Yeni Marka', value: null, type: 'product-brands'},...dependencies['product-brands']]"
                           @change="changeBrandSelect"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Kategori">
            <b-form-select v-model="service.category_id" :options="dependencies['product-categories']"/>
          </b-form-group>
        </b-col>
      </b-row>


      <b-row>
        <b-col>
          <b-form-group label="Alış Fiyatı">
            <b-form-input v-model="service.purchase_price" type="number"/>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Satış Fiyatı">
            <b-form-input v-model="service.price" type="number"></b-form-input>
          </b-form-group>
        </b-col>
<!--        <b-col>-->
<!--          <b-form-group label="Kira Fiyatı">-->
<!--            <b-form-input v-model="service.rent_price" type="number"/>-->
<!--          </b-form-group>-->
<!--        </b-col>-->
        <b-col>
          <b-form-group label="KDV Oranı">
            <b-form-input v-model="service.tax" type="number"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Açıklama">
            <b-form-textarea v-model="service.description"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

<!--      <label class="d-flex-align-items-center">-->
<!--        <switches v-model="service.barcode_rent_price" theme="custom" color="red"/>-->
<!--        <span>Kira Fiyatı Barkodda Görünsün</span>-->
<!--      </label>-->

<!--            <label class="d-flex-align-items-center">-->
<!--              <switches v-model="service.included_tax" theme="custom" color="red" />-->
<!--              <span>Satış Fiyatına KDV Dahil</span>-->
<!--            </label>-->

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="resetAndHideModal">{{ $t("İptal") }}</b-button>
        <b-button variant="primary" @click="submitModal" :disabled="$v.$invalid">{{ $t("Kaydet") }}</b-button>
      </template>
    </b-modal>


    <b-modal title="Barkod" size="md" ref="barcodeModal">
      <div class="row align-items-center">
        <div class="col-md-4">
          <img :src="product.barcode_logo" class="img-fluid" style="width: 150px; height: 150px" alt=""
               v-if="user.company.print_company_logo">

        </div>

        <div class="col-md-8" style="font-size:14px !important">
          <div class="d-flex align-items-center">
            <div>
              <pre class="mb-1">{{ product.name }}<br><span
                  v-if="user && user.company && user.company.print_sale_price">{{ $t("Satış Fiyatı") }}:{{
                  Math.ceil(product.total)
                }}TL</span> <br><span
                  v-if="user && user.company && user.company.print_rent_price && product.barcode_rent_price">{{
                  $t("Kira Fiyatı")
                }}:{{
                  product.rent_price
                }}TL</span></pre>
            </div>
            <div v-if="user.company.qrcode_in_barcode">
              <vue-qr ref="qr" :text="base+'/urunler/'+product.id" :size="110"></vue-qr>
            </div>
          </div>
          <div id="printable-barcode" v-if="user.company.barcode_in_barcode" v-html="barcodeHTML"></div>
          <pre class="mt-1" v-if="user.company.barcode_in_barcode">{{ product.barcode }}</pre>
        </div>

      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$refs.barcodeModal.hide()">{{ $t("Kapat") }}</b-button>
        <b-button variant="primary" @click="printBarcode(product.barcode_rent_price)">{{ $t("Yazdır") }}</b-button>
      </template>
    </b-modal>
    <b-modal ref="newBrandModal" title="Yeni Marka" @hide="hideNewBrandModal">
      <b-form-group label="Başlık">
        <b-form-input v-model="newBrand"></b-form-input>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button @click="$refs.newBrandModal.hide()">İptal</b-button>
        <b-button @click="submitNewModal()" variant="primary" class="loading-button">
          <i v-if="buttonLoading" class="fa fa-spinner"></i> {{ $t("Kaydet") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Switches from 'vue-switches'
import {required} from 'vuelidate/lib/validators'
import moment from 'moment'
import {imageBase} from "../../config";
import VueQr from 'vue-qr'

export default {
  components: {Switches, VueQr},
  validations: {
    service: {
      name: {required},
      price: {required},
      tax: {required},
    }
  },
  computed: {
    ...mapGetters(['user']),
    baseURL() {
      return imageBase;
    },
    base() {
      return window.location.origin
    },
    getType() {
      return this.$route.params.type
    },
    fields() {
      let fields = [
        {key: 'name', label: 'Ürün Adı'},
        {key: 'category', label: 'Kategori'},
        {key: 'barcode', label: 'Barkod'},
        // {key: 'purchase_price', label: 'Alış Fiyatı'},
        // { key: 'price', label: 'Satış Fiyatı' },
        // { key: 'tax', label: 'KDV Oranı' },
        // { key: 'total', label: 'KDV Dahil' },
        {key: 'total', label: 'Satış Fiyatı'},
        // {key: 'rent_price', label: 'Kira Fiyatı'},
        {key: 'stock', label: 'Stok'},
        {key: 'daycount', label: 'Hizmet Süresi'},
        // {key: 'lease_count', label: 'Kaç Kez Kiraya Verildi'},
        // {key: 'year', label: 'Yıl'},
        // {key: 'size', label: 'Beden'},
      ]

      if (this.getType == 'all')
        fields.push({key: 'company.full_name', label: 'Bayi'})
      else
        fields.push({key: 'actions', label: '', tdClass: 'text-right'})

      return fields;
    }
  },
  mounted() {
  },
  data() {
    return {
      newBrand: '',
      companies: [],
      buttonLoading:false,
      company: null,
      perPage: 7,
      keyword: '',
      cPage: 1,
      orderByStock: false,
      submitType: 'create',
      productsCount: 0,
      categoriesCount: 0,
      brandsCount: 0,
      services: [],
      dependencies: {},
      id: '',
      lease: {},
      rents: [],
      clients: [],
      brand: 'all',
      category: 'all',
      brands: [],
      categories: [],
      monthlyLeaseCount: 0,
      product: '',
      activeItem: '',
      barcodeHTML: '',
      service: {
        barcode_rent_price: true,
        name: '',
        price: '',
        tax: 0,
        included_tax: true,
        rent_price: 0,
        purchase_price: 0,
        size: null,
        year: null,
        used_time:0,
        daycount:-1,
        hizmetsuresi:true,
        description:"",


      },
      pagination: {
        currentPage: 1,
        totalRows: 1,
        perPage: 15,
      },
    }
  },
  created() {
    if (!this.user.yearsize_permission) {
      this.fields = this.fields.filter(field => field.key != 'size' && field.key != 'year')
    }
    if (this.type != "all") {
      this.fields = this.fields.filter(field => field.key != 'bayi')
    }
  },
  methods: {
    ...mapActions(['getServices', 'getDeletedServices', 'getLeasesByService', 'createService', 'updateService', 'deleteService', 'leaseAction', 'createBarcodeHTML','createCategory']),
    submitNewModal() {
      this.buttonLoading = true;

      this.createCategory({name:this.newBrand,type:'product-brands'})
          .then(res => {
            this.success(res.data.message);
            this.buttonLoading = false;
            this.$refs.newBrandModal.hide()
          }).catch(error => {
        this.buttonLoading = false;
        this.error(error.response.data.message);
      });
    },
    changeBrandSelect() {
      if (this.service.brand_id == null) {
        this.$refs.newBrandModal.show()
      }
    },
    hideNewBrandModal() {
        this.getItems()
    },
    changeCategory() {
      this.cPage = 1;
      this.refreshTable()
    },
    printBarcode(barcode_rent_price) {
      // Open the print window
      let qrCode = this.$refs.qr.imgUrl;
      const prtHtml = document.getElementById('printable-barcode').innerHTML;
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
<!--          <style>-->
<!--            svg { width: 100% !important; height: 100% !important; }-->
<!--          </style>-->
          </head>
          <body>
          <div style="display:flex;">
          <img style="width: 100px; height: 100px; float: left; margin-top: 10px;  margin-right: 30px; ${!this.user.company.print_company_logo ? 'display:none' : ''}" src="${this.product.barcode_logo}" alt="">

           <div>
            <div style="display:flex; justify-content:space-between">
            <pre>${this.product.name}
            ${this.user.company.print_sale_price ? `<br>Satış Fiyatı:${Math.ceil(this.product.total)}TL` : ''}
             ${this.user.company.print_rent_price ? `<br>Kira Fiyatı:${this.product.rent_price}TL` : ''}</pre>
            ${this.user.company.qrcode_in_barcode ? `<img src="${qrCode}" alt="">` : ''}
                    </div>
            ${this.user.company.barcode_in_barcode ? `<div>
            ${prtHtml} <br />
            ${this.product.barcode}
</div>` : ''}
</div>


</div>
          </body>
        </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    openBarcodeModal(p) {
      this.product = p;
      console.log(this.product.id)
      this.createBarcodeHTML(p.barcode).then(response => {
        this.barcodeHTML = response.data;
        this.$refs.barcodeModal.show();
      }).catch(error => {
        this.error(error.response.data.message);
      })
    },
    leaseModal(item) {
      this.lease = {
        service_id: item.id,
        total_price: item.rent_price,
      };
      this.$refs.leaseModal.show();
    },
    rentModal(item) {
      this.getLeasesByService(item.id).then(res => {
        this.activeItem = item.name;
        this.rents = res.data;
        this.rents.forEach(rent => {
          rent.issue_date = moment(rent.issue_date).format('DD-MM-YYYY')
          rent.delivery_date = moment(rent.delivery_date).format('DD-MM-YYYY')
        })
      })
      this.$refs.rentModal.show();
    },
    leaseProduct() {
      this.leaseAction(this.lease).then(response => {
        this.success(response.data.message);
        this.refreshTable();
        this.$refs.leaseModal.hide();
      }).catch(error => {
        this.error(error.response.data.message);
      });
    },
    submitModal() {
      console.log(this.service)
      if (this.submitType === 'update') {
        this.updateService({
          id: this.id,
          service: this.service,
        }).then(response => {
          this.success(response.data.message)
          this.hideModal()
          this.refreshTable()
        }).catch(error => {
          this.error(error.response.data.message)
        })
      } else {
        this.createService(this.service)
            .then(response => {
              this.success(response.data.message)
              this.hideModal()
              this.refreshTable()
            }).catch(error => {

          this.format(error.response.data.errors).forEach(item => {

            this.error(item)
          })
        })
      }
    },
    format(obj) {
      return [].concat(Object.values(obj)).flat(10);
    },
    editService(service) {
      this.submitType = 'update'
      const item = JSON.parse(JSON.stringify(service))
      this.id = item.id
      this.service = item;
      this.openModal()
    },
    deleteAction(id) {
      this.$swal({
        icon: 'warning',
        title: 'Dikkat',
        text: 'Hizmet kalici olarak silinecektir, emin misiniz?',
      }).then(ok => {
        if (ok.value) {
          this.deleteService(id).then(response => {
            this.success(response.data.message)
            this.refreshTable()
          }).catch(error => {
            this.error(error.response.data.message)
          })
        }
      })
    },
    refreshTable() {
      this.$refs.table.refresh()
    },
    getItems() {
      const parameters = this.parameters()
      return this.getServices(parameters)
          .then(data => data.data).then(response => {
            const services = response.services;
            this.productsCount = response.products_count;
            this.categoriesCount = response.categories_count;
            this.dependencies = response.dependencies;
            this.monthlyLeaseCount = response.monthly_lease_count.toString();
            this.services = services
            this.brands = response.brands;
            this.categories = response.categories;
            this.brandsCount = response.brands.length;
            this.brands.unshift({
              text: 'Tüm Markalar',
              value: 'all',
            });
            if (this.getType == 'all') {

              this.companies = response.companies;
              this.companies.unshift({
                text: 'Tüm Bayiler',
                value: null,
              });
            }
            this.categories.unshift({
              text: 'Tüm Kategoriler',
              value: 'all',
            });
            this.clients = response.clients;

            this.pagination.totalRows = services.total
            return services.data;
          })
    },
    parameters() {
      const params = {}
      if (this.getType == "all")
        params.getType = "all"
      params.company = this.company
      // params.page = JSON.parse(JSON.stringify(this.pagination.currentPage))
      params.page = this.cPage
      params.perPage = this.perPage
      if (this.keyword.length > 0) {
        params.keyword = this.keyword;
      }
      if (this.orderByStock) {
        params.order_by_stock = 1;
      } else {
        params.order_by_stock = 2;
      }
      params.brand = this.brand;
      params.category = this.category;
      return params;
    },
    resetAndHideModal() {
      this.resetModal()
      this.hideModal()
    },
    openModal() {
      this.$refs.modal.show()
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    resetModal() {
      this.submitType = 'create'
      this.service = {
        title: '',
        price: '',
        tax: 18,
        included_tax: true,
      }
    },
  },
  watch: {
    keyword() {
      this.refreshTable();
    }
  }
}
</script>


<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

html{
  overflow: -moz-scrollbars-horizontal !important;
  overflow-x:hidden !important;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>